import React from 'react'

export interface DeltaTrialTimelineElementProps {
  day: string
  text: string
  icon: string
}

export const DeltaTrialTimelineElement: React.FC<DeltaTrialTimelineElementProps> = ({ day, text, icon }) => {
  return (
    <div className='d-flex flex-column gap-1 position-relative'>
      <div className='paragraph-medium bold'>{day}</div>
      <div className='paragraph-small zocks-text-gray-600'>{text}</div>
      <i className={`bi ${icon} position-absolute delta-trial-timeline-icon`} />
    </div>
  )
}
